module.exports = __webpack_public_path__ + "img/menu_map_green_icon.779f877c.svg";